import { ArrayInput, FormDataConsumer, SimpleFormIterator } from "react-admin";
import JournalInputs from "./JournalInputs";

export default function BadDebtCorrectionJournalForm() {
  return (
    <ArrayInput
      source="bad_debt_correction_journals"
      defaultValue={[
        {
          chart_of_account_id: "", // "76539dda-cecd-4ac9-9ae2-2cc216306363", // FIXME: sesuaikan dgn ID FORECASTED UNCOLLECTIBLE AR
          debit: 0,
          credit: 0,
        },
        {
          chart_of_account_id: "",
          debit: 0,
          credit: 0,
        },
      ]}
    >
      <SimpleFormIterator
        fullWidth={true}
        inline={true}
        sx={{
          "& .RaSimpleFormIterator-form": {
            width: "100%",
          },
          "& .RaSimpleFormIterator-line": {
            borderBottom: "none",
          },
        }}
        // getItemLabel={(index) => `#${index + 1}`}
        disableRemove
        disableClear
        disableReordering
        disableAdd
      >
        <FormDataConsumer>{JournalInputs}</FormDataConsumer>
      </SimpleFormIterator>
    </ArrayInput>
  );
}
